import { jsx } from 'react/jsx-runtime';
import { IconBase } from '@vds/core';

const CloseBold = (props) => (jsx(IconBase, Object.assign({}, props, { svgContent: jsx("g", { id: "close-bold", children: jsx("path", { id: "Vector", fillRule: "evenodd", clipRule: "evenodd", d: "M10.0174 3.27307L7.2911 5.99934L10.0174 8.72565L8.72886 10.0142L6.00259 7.28786L3.27628 10.0142L1.98779 8.72565L4.71407 5.99934L1.98779 3.27307L3.27628 1.98456L6.00259 4.71086L8.72886 1.98456L10.0174 3.27307Z" }) }), viewBox: "0 0 12 12", iconName: "close-bold" })));
CloseBold.displayName = 'VDS_Icon';

export { CloseBold as default };
